<script setup lang="ts">
import { computed } from 'vue'
import { indicatorsForType } from '@/interfaces/entities/management'

const props = defineProps<{
  sensorType: string | null | undefined
  modelValue: string[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void
}>()

const options = computed(() => indicatorsForType(props.sensorType ?? ''))

function toggle(key: string) {
  const set = new Set(props.modelValue)
  if (set.has(key)) {
    set.delete(key)
  } else {
    set.add(key)
  }
  emit('update:modelValue', Array.from(set))
}
</script>

<template>
  <div>
    <p v-if="!options.length" class="text-sm text-slate-500">
      Este tipo de sensor não possui indicadores configuráveis.
    </p>
    <div v-else class="grid grid-cols-1 gap-2 sm:grid-cols-2">
      <label
        v-for="option in options"
        :key="option.key"
        class="flex cursor-pointer items-center gap-2 border border-stroke px-3 py-2 text-sm transition hover:bg-slate-50"
        :class="{ 'border-primary bg-primary/5': modelValue.includes(option.key) }">
        <input
          type="checkbox"
          class="h-4 w-4 accent-primary"
          :checked="modelValue.includes(option.key)"
          @change="toggle(option.key)" />
        <span class="text-slate-700">{{ option.label }}</span>
        <span class="ml-auto text-xs text-slate-400">{{ option.unit }}</span>
      </label>
    </div>
  </div>
</template>
